import { TooltipProvider } from '@radix-ui/react-tooltip'
import React from 'react'
import { CookiesProvider } from 'react-cookie'
import ReactDOM from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { WagmiConfig } from 'wagmi'
import { AuthProvider } from './features/auth-provider'
import { ReactQueryClientProvider } from './features/react-query-provider'
import { SnackbarProvider } from './features/snackbar-provider'
import { withLDConfig } from './features/with-ld'
import {
  CompetitionRoute,
  FallbackRoute,
  GenesisListenRoute,
  GenesisRoute,
  HomeRoute,
  LandingRoute,
  LayoutRoute,
  LegalRoute,
  PacksRoute,
  ProfilePageRoute,
  SampleDetailsRoute,
  SamplePacksRoute,
  SongDetailsRoute,
  SongPreviewRoute,
  SoundsRoute,
  StemDetailsRoute,
  StudioRoute
} from './pages'
import { WindowResizeContextProvider } from './__legacy__/hooks/useWindowSize'
import Web3Client from './__legacy__/lib/wagmi/connectors'

const router = createBrowserRouter([
  {
    ...LayoutRoute,
    index: false,
    children: [
      HomeRoute,
      SongDetailsRoute,
      StemDetailsRoute,
      SampleDetailsRoute,
      ProfilePageRoute,
      SamplePacksRoute,
      SongPreviewRoute,
      CompetitionRoute,
      SoundsRoute,
      PacksRoute,
      FallbackRoute
    ]
  },
  LandingRoute,
  StudioRoute,
  GenesisRoute,
  GenesisListenRoute,
  LegalRoute
])

const rootContainer = document.getElementById('app')
const root = ReactDOM.createRoot(rootContainer)

const rectangle = { width: window.innerWidth, height: window.innerHeight }

const App = withLDConfig()(() => (
  <ReactQueryClientProvider>
    <WagmiConfig client={Web3Client}>
      <AuthProvider>
        <WindowResizeContextProvider value={rectangle}>
          <CookiesProvider>
            <SnackbarProvider>
              <TooltipProvider>
                <RouterProvider router={router} />
              </TooltipProvider>
            </SnackbarProvider>
          </CookiesProvider>
        </WindowResizeContextProvider>
      </AuthProvider>
    </WagmiConfig>
  </ReactQueryClientProvider>
))

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
